import { ConnectionSelector } from "../../connection-selector/connection-selector";
import { ConversationTagSelector } from "../../converation-tag-selector";
import { MessageFromSelector } from "./components/message-from-selector";
import { StandardDateInput } from "./components/standard-date-input";
import {
  StandardTextAreaInput,
  StandardTextInput,
} from "./components/standard-text-input";

import { Select } from "antd";
import { ConnectionLabel } from "components/modules/connections/connection-pill/connection-pill";
import { TicketTypeSelector } from "components/pages/tickets/components/ticket-type-selector/ticket-type-selector";
import dayjs from "dayjs";
import { MultiPhraseInput } from "./components/multi-phrase-input";
import { iAutomationRuleCondition } from "./models";

export const AllAutomationRuleConditionConfigurations: iAutomationRuleCondition[] =
  [
    //  Message related
    {
      label: "Message",
      key: "message_text",
      section: "Message",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the message text",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Enter a phrase to match against the message text. The phrase will be evaluated for for partial match",
          widget: StandardTextInput,
        },
        {
          key: "matches_ai_condition",
          label: "matches AI condition",
          help: "Use AI to match the message text against a condition provided above",
          widget: StandardTextAreaInput,
        },
      ],
    },
    {
      label: "Message Sender",
      key: "message_senderType",
      section: "Message",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the message text",
          widget: MessageFromSelector,
        },
      ],
    },
    // Page Visit
    {
      label: "Visited Page URL",
      section: "Context",
      key: "context_visitedUrl",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the message text",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Enter a phrase to match against the message text. The phrase will be evaluated for for partial match",
          widget: StandardTextInput,
        },
      ],
    },

    // Session Related
    {
      label: "Session Landed Page URL",
      section: "Session",
      key: "session_landedPage",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the message text",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Enter a phrase to match against the message text. The phrase will be evaluated for for partial match",
          widget: StandardTextInput,
        },
      ],
    },
    {
      label: "Session Referer URL",
      section: "Session",
      key: "session_referer",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the message text",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Enter a phrase to match against the message text. The phrase will be evaluated for for partial match",
          widget: StandardTextInput,
        },
      ],
    },
    {
      label: "Session",
      section: "Session",
      key: "session_verification",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the message text",
          // Todo: verified not verified
          widget: StandardTextInput,
        },
      ],
    },
    {
      label: "Session country",
      section: "Session",
      key: "session_country",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the message text",
          // Todo: country selector
          widget: StandardTextInput,
        },
      ],
    },
    // Conversation Related
    {
      label: "Conversation Tags",
      section: "Conversation",
      key: "conversation_tags",
      operators: [
        {
          key: "has",
          label: "includes",
          widget: ConversationTagSelector,
        },
      ],
    },
    {
      label: "Conversation Subject",
      section: "Conversation",
      key: "conversation_subject",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the subject text",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Enter a phrase to match against the subject text. The phrase will be evaluated for for partial match",
          widget: StandardTextInput,
        },
      ],
    },
    {
      label: "Connection",
      section: "Conversation",
      key: "conversation_connection",
      operators: [
        {
          key: "is",
          label: "is",
          widget: ConnectionSelector,
          labelRender: (connectionId) => (
            <ConnectionLabel connectionId={connectionId} />
          ),
        },
      ],
    },
    {
      label: "Last FB Ad Name",
      section: "Conversation",
      key: "conversation_last_fb_ad_name",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Match against the last referenced FB ad name",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Partially match against the last referenced FB ad name",
          widget: StandardTextInput,
        },
      ],
    },
    {
      label: "Last FB Ad ID",
      section: "Conversation",
      key: "conversation_last_fb_ad_id",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Match against the last referenced FB ad id",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Partially match against the last referenced FB ad id",
          widget: StandardTextInput,
        },
      ],
    },
    // Todo: Conversation Started Page, Status, Subject
    // Contact Related
    {
      label: "Customer Tags",
      section: "Customer",
      key: "contact_tags",
      operators: [
        {
          key: "has",
          label: "has",
          widget: ConversationTagSelector,
        },
      ],
    },
    {
      label: "Customer Email",
      section: "Customer",
      key: "contact_email",
      operators: [
        {
          key: "is",
          label: "is",
          // Todo: Available, not available
          widget: ConversationTagSelector,
        },
      ],
    },
    {
      label: "Customer record created date",
      section: "Customer",
      key: "contact_createdDate",
      operators: [
        {
          key: "is_before",
          label: "is before",
          widget: StandardDateInput,
          labelRender: (timestamp) => (
            <>{dayjs(timestamp).format("LL h:mm a")}</>
          ),
        },
        {
          key: "is_after",
          label: "is after",
          widget: StandardDateInput,
          labelRender: (timestamp) => (
            <>{dayjs(timestamp).format("LL h:mm a")}</>
          ),
        },
      ],
    },
    // Ticket Related
    {
      label: "Ticket Tags",
      section: "Ticket",
      key: "ticket_tags",
      operators: [
        {
          key: "has",
          label: "has",
          widget: (props) => (
            <Select
              {...props}
              mode="tags"
              placeholder="Add tags"
              dropdownStyle={{ display: "none" }}
            />
          ),
        },
      ],
    },
    {
      label: "Ticket Type",
      section: "Ticket",
      key: "ticket_ticketTypeId",
      operators: [
        {
          key: "is",
          label: "is",
          widget: TicketTypeSelector,
        },
      ],
    },
    //* Could Add Ticket Stage with only default values
    // {
    //   label: "Ticket Stage",
    //   section: "Ticket",
    //   key: "ticket_ticketStageId",
    //   operators: [
    //     {
    //       key: "is",
    //       label: "is",
    //       // Todo: Available, not available
    //       widget: ConversationTagSelector,
    //     },
    //   ],
    // },
    {
      label: "Ticket Description",
      section: "Ticket",
      key: "ticket_body",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the Ticket description",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Enter a phrase to match against the Ticket description. The phrase will be evaluated for for partial match",
          widget: StandardTextInput,
        },
      ],
    },
    {
      label: "Ticket Label",
      section: "Ticket",
      key: "ticket_label",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the Ticket Label",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Enter a phrase to match against the Ticket Label. The phrase will be evaluated for for partial match",
          widget: StandardTextInput,
        },
      ],
    },
    // WA Referral Signal
    {
      label: "Referral Source ID",
      section: "WA Referral",
      key: "wa_referral_signal_source_id",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Match against the WA referral source ID",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Partially match against the WA referral source ID",
          widget: StandardTextInput,
        },
      ],
    },
    {
      label: "Referral Body",
      section: "WA Referral",
      key: "wa_referral_signal_body",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Match against the WA referral body text",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Partially match against the WA referral body text",
          widget: StandardTextInput,
        },
      ],
    },
    {
      label: "Referral Headline",
      section: "WA Referral",
      key: "wa_referral_signal_headline",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Match against the WA referral headline",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Partially match against the WA referral headline",
          widget: StandardTextInput,
        },
      ],
    },
    // Fb Comments Related
    {
      label: "Connection",
      section: "FB Comments",
      key: "fbComment_connectionId",
      operators: [
        {
          key: "is",
          label: "is",
          widget: ConnectionSelector,
          labelRender: (connectionId) => (
            <ConnectionLabel connectionId={connectionId} />
          ),
        },
      ],
    },
    {
      label: "Post ID",
      section: "FB Comments",
      key: "fbComment_postId",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the post ID",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Enter a phrase to match against the post ID. The phrase will be evaluated for for partial match",
          widget: StandardTextInput,
        },
        {
          key: "is_not",
          label: "is not",
          help: "Enter a phrase to match against the post ID",
          widget: StandardTextInput,
        },
        {
          key: "is_not_any_of",
          label: "is not any of",
          help: "Enter a few phrases to match against the post ID. The phrase will be evaluated for for partial match",
          widget: MultiPhraseInput,
        },
      ],
    },
    {
      label: "Comment Content",
      section: "FB Comments",
      key: "fbComment_message",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the comment text",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Enter a phrase to match against the comment text. The phrase will be evaluated for for partial match",
          widget: StandardTextInput,
        },
        {
          key: "contains_any_of",
          label: "contains phrases",
          help: "Enter a few phrases to match against the comment text. The phrase will be evaluated for for partial match",
          widget: MultiPhraseInput,
        },
        {
          key: "matches_ai_condition",
          label: "matches AI condition",
          help: "Use AI to match the comment text against a condition provided above",
          widget: StandardTextAreaInput,
        },
      ],
    },
    {
      label: "Comment Contains",
      section: "FB Comments",
      key: "fbComment_hasUserTags",
      operators: [
        {
          key: "is_truthy",
          label: "Mentions",
          help: "Whether the comment contains any user tags",
          widget: (props) => (
            <Select
              {...props}
              placeholder="Select Option"
              options={[
                {
                  label: "Yes",
                  value: "true",
                },
                {
                  label: "No",
                  value: "false",
                },
              ]}
            />
          ),
        },
      ],
    },
    {
      label: "Private Reply",
      key: "private_reply_text",
      section: "Private Reply",
      operators: [
        {
          key: "is",
          label: "is",
          help: "Enter a phrase to match against the private reply text",
          widget: StandardTextInput,
        },
        {
          key: "contains",
          label: "contains",
          help: "Enter a phrase to match against the private reply text. The phrase will be evaluated for for partial match",
          widget: StandardTextInput,
        },
        {
          key: "contains_any_of",
          label: "contains phrases",
          help: "Enter a few phrases to match against the private reply text. The phrase will be evaluated for for partial match",
          widget: MultiPhraseInput,
        },
        {
          key: "contains_all_of",
          label: "contains all of",
          help: "Enter a few phrases to match against the private reply text. All phrases must match",
          widget: MultiPhraseInput,
        },
        {
          key: "contains_none_of",
          label: "contains none of",
          help: "Enter a few phrases to match against the private reply text. None of the phrases should match",
          widget: MultiPhraseInput,
        },
        {
          key: "is_not",
          label: "is not",
          help: "Enter a phrase to match against the private reply text",
          widget: StandardTextInput,
        },
      ],
    },
  ];
